// TODO: @Sireesha, Please type this file and it's dep
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { checkEnvironment, Logger } from '@saviynt/common';
import { Cookies } from 'react-cookie';

/**
 * HttpService is a utility class for making HTTP requests.
 * It uses the Fetch API under the hood and provides methods
 * for setting, deleting, and resetting headers.
 *
 * This class is exported as both a singleton instance and a class.
 * You can import the singleton instance for shared use across the
 * application, or import the class to create a new instance.
 * For simple http calls, it's recommended to use the singleton instance.
 *
 * @example
 * // Importing the singleton instance:
 * import HttpServiceSingleton from 'HttpService';
 * When using the singleton, do not modify headers as this can affect other
 * calls that are using the shared instance while your modified call is in flight.
 *
 * // Importing the class to create a new instance:
 * import { HttpService } from 'HttpService';
 * const httpServiceObj = new HttpService();
 * httpServiceObj.deleteHeader('Content-Type');
 *
 * @export
 * @class HttpService
 */
export class HttpService {
  constructor() {
    this.cookies = new Cookies();
    this.initialHeaders = () => ({
      'Content-Type': 'application/json',
      ...(checkEnvironment().FEATURE_HTTPONLY_ACCESSTOKEN ?? {
        Authorization: `${this.cookies.get('token_type')} ${this.cookies.get(
          'access_token'
        )}`,
      }),
    });
  }

  /**
   * Reads the XSRF-TOKEN-EXT cookie value for CSRF protection.
   * @returns The XSRF token string, or undefined if not set.
   */
  getXsrfToken() {
    return this.cookies.get('XSRF-TOKEN-EXT');
  }

  /**
   * Returns headers for state-changing requests (POST/PUT/DELETE/PATCH)
   * with the X-XSRF-TOKEN-EXT header included when the cookie is available.
   */
  getStateChangingHeaders() {
    const headers = this.headers || this.initialHeaders();
    const xsrfToken = this.getXsrfToken();

    if (xsrfToken) {
      return { ...headers, 'X-XSRF-TOKEN-EXT': xsrfToken };
    }

    return headers;
  }

  setHeaders(headers) {
    this.headers = {
      ...(this.headers || this.initialHeaders()),
      ...headers,
    };
  }

  deleteHeader(headerName) {
    this.headers = this.headers || this.initialHeaders();
    delete this.headers[headerName];
  }

  resetHeaders() {
    this.headers = this.initialHeaders();
  }

  get(url, signal) {
    return fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: this.headers || this.initialHeaders(),
      ...(signal ? { signal } : {}),
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        }

        // For non-OK responses, parse error and throw to enable proper error handling
        // This allows React Query and other consumers to catch errors properly
        let errorBody = {};

        try {
          errorBody = await res.json();
        } catch {
          // Response body might not be JSON
        }

        const error = new Error(
          errorBody.errorMessage ||
            errorBody.message ||
            `Request failed with status ${res.status}`
        );

        error.status = res.status;
        error.details = errorBody;
        throw error;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }

  post(
    url,
    req,
    errorCallback,
    signal,
    shouldStringifyBody = true,
    wrap = true
  ) {
    const body = shouldStringifyBody ? JSON.stringify(req) : req;

    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: this.getStateChangingHeaders(),
      body,
      signal,
    })
      .then(async (res) => {
        const contentType = res.headers.get('content-type');
        let data;

        if (contentType?.includes('application/json')) {
          data = await res.json();
        }

        if (res.ok) {
          // Some APIs return JSON with a missing or non-JSON Content-Type; body was not read above.
          if (data === undefined) {
            const text = await res.text();

            if (text) {
              try {
                data = JSON.parse(text);
              } catch {
                data = text;
              }
            }
          }

          return wrap ? { status: res.status, data } : data;
        }

        // For non-OK responses, throw to enable proper error handling
        // This allows React Query and other consumers to catch errors properly
        if (errorCallback && typeof errorCallback === 'function') {
          errorCallback();
        }

        const error = new Error(
          data?.errorMessage ||
            data?.message ||
            `Request failed with status ${res.status}`
        );

        error.status = res.status;
        error.details = data;
        throw error;
      })
      .catch((err) => {
        Logger.log(err);

        // Re-throw all errors to allow proper error handling
        throw err;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }

  put(url, req, errorCallback, shouldStringifyBody = true) {
    const body = shouldStringifyBody ? JSON.stringify(req) : req;

    return fetch(url, {
      method: 'PUT',
      credentials: 'include',
      headers: this.getStateChangingHeaders(),
      body,
    })
      .then(async (res) => {
        const contentType = res.headers.get('content-type');
        let data;

        if (contentType?.includes('application/json')) {
          data = await res.json();
        }

        if (res.ok) {
          return { status: res.status, data };
        }

        // For non-OK responses, throw to enable proper error handling
        // This allows React Query and other consumers to catch errors properly
        if (errorCallback && typeof errorCallback === 'function') {
          errorCallback();
        }

        const error = new Error(
          data?.errorMessage ||
            data?.message ||
            `Request failed with status ${res.status}`
        );

        error.status = res.status;
        error.details = data;
        throw error;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }

  delete(url, req, errorCallback, shouldStringifyBody = true) {
    const body = shouldStringifyBody ? JSON.stringify(req) : req;

    return fetch(url, {
      method: 'DELETE',
      credentials: 'include',
      headers: this.getStateChangingHeaders(),
      body,
    })
      .then(async (res) => {
        if (res.ok) {
          const contentType = res.headers.get('content-type');

          if (contentType?.includes('application/json')) {
            return res.json();
          }

          return res;
        }

        // For non-OK responses, throw to enable proper error handling
        // This allows React Query and other consumers to catch errors properly
        let errorBody = {};

        try {
          errorBody = await res.json();
        } catch {
          // Response body might not be JSON
        }

        if (errorCallback && typeof errorCallback === 'function') {
          errorCallback();
        }

        const error = new Error(
          errorBody.errorMessage ||
            errorBody.message ||
            `Request failed with status ${res.status}`
        );

        error.status = res.status;
        error.details = errorBody;
        throw error;
      })
      .finally(() => {
        this.resetHeaders();
      });
  }
}

export default new HttpService();
